"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _all = require("animations-json/build/all");

var _LottieAnimationBase = _interopRequireDefault(require("../LottieAnimationBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Animation64 = /*#__PURE__*/function (_AnimationBase) {
  _inherits(Animation64, _AnimationBase);

  var _super = _createSuper(Animation64);

  function Animation64(animObj) {
    var _this;

    _classCallCheck(this, Animation64);

    var animationId = animObj.animationId;
    var data = animObj.data;
    var config = {
      default: {
        colors: ['#FFF', '#FD508F']
      },
      maxCharInline: 1000,
      minLines: 1,
      maxLines: 6,
      lineHeight: {
        base: 450,
        extra: 0
      },
      width: 660,
      height: 500,
      textShadow: false,
      inDuration: 1320,
      intermissionDuration: 3000,
      outDuration: 1280,
      totalDuration: 5600
    };
    _this = _super.call(this, animObj, data, config);
    var animation = (0, _all.getAnimationJson)(animationId); // set colors
    // replace with color 1

    var fonColorPattern = new RegExp('"fc":\\[1,1,1]', 'g');
    var shapeColorPattern1 = new RegExp('\\[0.992156922817,0.313725501299,0.560784339905,1]', 'g');
    animation = animation.replace(fonColorPattern, "\"fc\":[".concat(_this.colors[0], "]")).replace(shapeColorPattern1, "[".concat(_this.colors[1], "]")); // replace place holders with the line value

    for (var i = 0; i < config.maxLines; i++) {
      var line = _this.lines.length > i ? _this.lines[i] : '';
      var regx = new RegExp("{#DYNAMICINPUT_0".concat(i + 1, "#}"), 'g');
      animation = animation.replace(regx, line);
    } // update fonts list for this animation


    if (!_this.fonts || _this.fonts.length === 0) {
      _this.fonts = [{
        font: 'Anton',
        weight: 400
      }];
    } // parse string to object


    _this.json = JSON.parse(animation);
    return _this;
  }

  return Animation64;
}(_LottieAnimationBase.default);

exports.default = Animation64;